import React from "react";
import EntityForm from "../../EntityForm/EntityForm";
import { entityToFormValuesMapper } from "../../../Common/utils";
import { RESTRICTION_TYPE, WEEK_DAYS } from "../../../Common/constants";
import { defineMessages, injectIntl } from "react-intl";

const messages = defineMessages({
  bothOrNone: {
    id: "app.entityForm.bothOrNoneHours",
    description: "Both range start and range end must be selected",
    defaultMessage: "Both range start and range end must be selected",
  },
  mustSetDateRange: {
    id: "app.entityForm.mustSetDateRange",
    description: "Date range must be set",
    defaultMessage: "Date range must be set",
  },
});

function customEntityToFormValuesMapper({ entity, fields, locales, translationConfig }) {
  const formValues = entityToFormValuesMapper({
    entity,
    fields,
    locales,
    translationConfig,
  });
  if (!formValues.restrictions) {
    formValues.restrictions = {
      [RESTRICTION_TYPE.OPEN_BOOKING]: [
        {
          startDate: null,
          endDate: null,
          weekDays: Object.values(WEEK_DAYS),
          startHour: null,
          endHour: null,
          timeZone: "Europe/Madrid",
        },
      ],
    };
  }

  return {
    ...formValues,
  };
}

class PromotionsBookingWindowForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  componentDidMount() {}

  componentWillUnmount() {}

  getFields(fields) {
    return fields && fields.form;
  }

  handleSubmit = ({ formValues }) => {
    const { id, ...otherFormValues } = formValues;

    const entity = otherFormValues;

    this.props.onSubmitEntity({
      entity,
    });
  };

  customValidate = formValues => {
    if (
      !formValues.restrictions.OPEN_BOOKING[0].startDate ||
      !formValues.restrictions.OPEN_BOOKING[0].endDate
    ) {
      return this.props.intl.formatMessage(messages.mustSetDateRange);
    }
    if (
      formValues.restrictions.OPEN_BOOKING[0].startHour &&
      !formValues.restrictions.OPEN_BOOKING[0].endHour
    ) {
      return this.props.intl.formatMessage(messages.bothOrNone);
    }
    return "";
  };

  render() {
    const { config } = this.props;
    const { name, validation, fields, renderers, translation, entities } = config;
    const {
      locales,
      entity,
      entityError,
      entityResult,
      loading,
      getListPath,
      nested,
      afterSubmit,
      onCancelEdit,
      entityName,
    } = this.props;
    const { getFields, handleSubmit } = this;
    return (
      <EntityForm
        loading={loading}
        name={name}
        entityName={entityName}
        entity={entity}
        entities={entities}
        validation={validation}
        renderers={renderers}
        fields={getFields(fields)}
        locales={locales}
        translation={translation}
        onSubmit={handleSubmit}
        entityError={entityError}
        customValidate={this.customValidate}
        entityResult={entityResult}
        getListPath={getListPath}
        nested={nested}
        afterSubmit={afterSubmit}
        onCancelEdit={onCancelEdit}
        entityToFormValuesMapper={customEntityToFormValuesMapper}
      />
    );
  }
}

PromotionsBookingWindowForm.propTypes = {};

PromotionsBookingWindowForm.defaultProps = {};

export default injectIntl(PromotionsBookingWindowForm);
